import { Component, OnInit } from '@angular/core';
// import * as $ from 'jquery';
// import $ from 'jquery';
declare var $: any;
// declare var window: any;
import { blogs } from '../../../assets/blogs';
import { Router } from '@angular/router';


@Component({
  selector: 'app-hg-blogs',
  templateUrl: './hg-blogs.component.html',
  styleUrls: ['./hg-blogs.component.css']
})
export class HgBlogsComponent implements OnInit {

  blogsList = [];

  constructor(private router: Router) {
    this.blogsList = blogs;
   }

  ngOnInit() {
}
readMore(count) {
  if(count == 'If you’re not saving energy, you’re burning money'){
    count = "if-youre-not-saving-energy-youre-burning-money";
  }else if(count == 'Why you shouldn’t trust anyone’s recommendation when it comes to this one thing.'){
    count = "why-you-shouldn’t-trust-anyones-recommendation-when-it-comes-to-this-one-thing";
  }else if(count == 'Your home as a fortress for well-being'){
    count = "your-home-as-a-fortress-for-wellbeing";
  }else if(count == '3 things you need to know before renting an apartment'){
    count = "3-things-you-need-to-know-before-renting-an-apartment";
  }
   
  this.router.navigate(['/blog/', count]);
 // this.residentialService.setArticleFlag({articleNum: this.articleNumber});
 // this.router.navigateByUrl('blog/' + count);
    // this.router.navigate(['/blog/article', {'article_number': count}]);
  // function testAnim(x) {
  //   $('.modal .modal-dialog').attr('class', 'modal-dialog  ' + x + '  animated');
  // }
  // $('#blogmodal').on('show.bs.modal', function (e) {
  // // const anim = $('#entrance').val();
  //     testAnim('expandIn');
  // });
//   $('.modal').each(function(l) {
//     $(this).on('show.bs.modal', function(e) {
//       // window.jQuery = window.$ = require('jquery');
//       // window.$.velocity = require('velocity-animate/velocity.js');
//       const open = $(this).attr('data-easein');
//       if (open === 'shake') {
//         $('.modal-dialog').velocity('callout.' + open);
//       } else if (open === 'pulse') {
//         $('.modal-dialog').velocity('callout.' + open);
//       } else if (open === 'tada') {
//         $('.modal-dialog').velocity('callout.' + open);
//       } else if (open === 'flash') {
//         $('.modal-dialog').velocity('callout.' + open);
//       } else if (open === 'bounce') {
//         $('.modal-dialog').velocity('callout.' + open);
//       } else if (open === 'swing') {
//         $('.modal-dialog').velocity('callout.' + open);
//       } else {
//         $('.modal-dialog').velocity('transition.' + open);
//       }
//     });
// });

}
}
